import useAuth from 'src/hooks/api/useAuth';

interface QuoteArticle {
  id: number;
  quantity?: number;
  productReference?: any;
  delivered?: boolean;
  waitingSupplier?: boolean;
}

interface GetQuoteArticlesResponse {
  quoteHardware?: QuoteArticle[];
  quoteVirtual?: QuoteArticle[];
  intermediateStageNumber: number;
  inStockHardware?: { inStock: boolean; reference?: { id?: number } }[];
}

export default () => {
  const { fetch } = useAuth();

  const getQuoteArticles = async (dealId: number): Promise<GetQuoteArticlesResponse> => {
    const queryURL =
      '/api/deal/show/{ deal(id:' +
      dealId +
      '){ id, ' +
      'agency { id, stock { id, products{ id, inStock, inOrder, reference{ id } } } }, ' +
      'stepProd { id, intermediateStageNumber, dealOrder{ id, intermediateStageNumber, quoteArticlesHardware{ id, quantity, productReference{ id, wording } }, quoteArticlesVirtual{ id, quantity, waitingSupplier, delivered, productReference{ id, wording } } } } ' +
      '} }';

    const response = await fetch(queryURL, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });

    const data = await response.json();

    if (data['data']['deal']['stepProd']['dealOrder']) {
      const inStockHardware = data['data']['deal']['agency']['stock']['products']
        ? data['data']['deal']['agency']['stock']['products']
        : [];

      return {
        quoteVirtual: data['data']['deal']['stepProd']['dealOrder']['quoteArticlesVirtual'],
        quoteHardware: data['data']['deal']['stepProd']['dealOrder']['quoteArticlesHardware'],
        intermediateStageNumber: data['data']['deal']['stepProd']['dealOrder']['intermediateStageNumber'],
        inStockHardware,
      };
    } else {
      return {
        quoteHardware: [],
        quoteVirtual: [],
        intermediateStageNumber: 1,
      };
    }
  };

  const updateDealOrderStepNumber = async (dealId: number, stepNumber: number): Promise<void> => {
    const payload = `mutation { deal(id:${dealId}, dealOrder: {intermediateStageNumber: ${stepNumber}}){id}}`;

    const response = await fetch('/api/stepProduction/updateOrder', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
      body: `payload=${encodeURIComponent(payload)}`,
    });

    const json = await response.json();

    if (json['errors']) {
      throw new Error();
    }
  };

  const updateQuote = async (
    dealId: number,
    quoteStateChangeId?: number,
    isWaiting?: boolean,
    isDelivered?: boolean
  ): Promise<void> => {
    const payload = `mutation { deal(id:${dealId}, quotesArticlesVirtual:[{id:${quoteStateChangeId}, waitingSupplier:${isWaiting}, delivered:${isDelivered}}]){id}}`;

    const response = await fetch('/api/stepProduction/updateOrder', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      method: 'POST',
      body: `payload=${encodeURIComponent(payload)}`,
    });

    const json = await response.json();

    if (json['data']['deal']['id'] !== dealId) {
      throw new Error();
    }
  };

  return { getQuoteArticles, updateQuote, updateDealOrderStepNumber };
};
